import React, {useState, useEffect} from "react"
import {useNavigate, useLocation} from "react-router-dom"
import CategorySlider from "../CategorySlider/CategorySlider"
import TableCards from "../Cards/TableCards"
import ListCards from "../Cards/ListCards"
import {IoMdArrowRoundBack} from "react-icons/io"
import {GoListUnordered} from "react-icons/go"
import {CiGrid41} from "react-icons/ci"
import {useLanguage} from "../../context/LanguageContext"
import "./ShowAllMenu.css"

export default function ShowAllMenu() {
  const [view, setView] = useState("table")
  const navigate = useNavigate()
  const location = useLocation()
  const {cardName, subCategoryId} = location.state || {}

  const {language} = useLanguage()

  const translations = {
    EN: {
      backButton: "Back",
    },
    TR: {
      backButton: "Geri",
    },
    RU: {
      backButton: "Назад",
    },
  }

  const currentTranslations = translations[language] || translations["TR"]

  useEffect(() => {
    //    console.log("Card Name:", cardName)
    //  console.log("Sub Category ID:", subCategoryId)
  }, [cardName, subCategoryId])

  const views = {
    table: (
      <>
        <CategorySlider cardName={cardName} subCategoryId={subCategoryId} />
        <TableCards cardName={cardName} subCategoryId={subCategoryId} />
      </>
    ),
    list: (
      <>
        <CategorySlider cardName={cardName} subCategoryId={subCategoryId} />
        <ListCards cardName={cardName} subCategoryId={subCategoryId} />
      </>
    ),
  }

  return (
    <div>
      <div className="subHeader">
        <button className="back-button" onClick={() => navigate("/")}>
          <IoMdArrowRoundBack />
          {currentTranslations.backButton}
        </button>
        <div className="table-list">
          <button onClick={() => setView("table")}>
            <CiGrid41 />
          </button>
          <button onClick={() => setView("list")}>
            <GoListUnordered />
          </button>
        </div>
      </div>
      <div className="cards">{views[view]}</div>
    </div>
  )
}
